export const EMPTY_DELIVERY_ADDRESS = {
  name: "",
  phone: "",
  email: "",
  address1: "",
  address2: "",
  city: "",
  state: "",
  country: "IN",
  pincode: "",
};

export function normalizeDeliveryAddress(raw = {}) {
  return {
    name: String(raw.name || "").trim(),
    phone: String(raw.phone || "").trim(),
    email: String(raw.email || "").trim(),
    address1: String(raw.address1 || raw.address || "").trim(),
    address2: String(raw.address2 || "").trim(),
    city: String(raw.city || "").trim(),
    state: String(raw.state || "").trim(),
    country: String(raw.country || "IN").trim().toUpperCase() || "IN",
    pincode: String(raw.pincode || raw.zip || "").replace(/\s/g, "").trim(),
  };
}

export function deliveryAddressFromQuotation(quotation) {
  if (!quotation) return { ...EMPTY_DELIVERY_ADDRESS };
  const saved = quotation.delivery_address
    ? normalizeDeliveryAddress(quotation.delivery_address)
    : null;

  return normalizeDeliveryAddress({
    name: saved?.name || quotation.contact_name || quotation.lead_title,
    phone: saved?.phone || quotation.contact_phone,
    email: saved?.email || quotation.contact_email,
    address1: saved?.address1 || quotation.contact_address,
    address2: saved?.address2,
    city: saved?.city || quotation.contact_city,
    state: saved?.state,
    country: saved?.country || quotation.contact_country || "IN",
    pincode: saved?.pincode,
  });
}

export function validateDeliveryAddress(address) {
  const addr = normalizeDeliveryAddress(address);
  if (!addr.name) return "Customer name is required";
  if (!addr.address1) return "Street address is required";
  if (!addr.city) return "City is required";
  if (!addr.pincode || !/^\d{6}$/.test(addr.pincode)) {
    return "Valid 6-digit PIN code is required";
  }
  return null;
}
